import React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { FormSelectRow } from "./form-select-row";
import { START_END_POINTS } from "../courier-constants";
import FormModalShell from "../ui/form-modal-shell";
import { CourierActions, CourierText } from "../ui/courier-fields";

const pointOptions = START_END_POINTS.map(p => ({
  value: p.value,
  label: p.label
}));

const CreateRoundForm = ({
  closeModal,
  loading,
  apiError,
  zones = [],
  createCourierRound
}) => (
  <FormModalShell title="Add Round" apiError={apiError} onClose={closeModal}>
    <Formik
      initialValues={{
        name: "",
        zone: "",
        startPoint: 1,
        endPoint: 1
      }}
      validationSchema={Yup.object().shape({
        name: Yup.string().required("Required field"),
        zone: Yup.string().required("Required field")
      })}
      onSubmit={values => {
        createCourierRound({
          name: values.name,
          zone: Number(values.zone),
          startPoint: Number(values.startPoint),
          endPoint: Number(values.endPoint)
        });
      }}
    >
      {formik => (
        <Form>
          <CourierText label="Round Name" name="name" />
          <FormSelectRow
            label="Zone"
            name="zone"
            value={formik.values.zone}
            onChange={e => formik.setFieldValue("zone", e.target.value)}
            error={formik.touched.zone && formik.errors.zone}
            required
            options={zones.map(z => ({ value: z.id, label: z.name }))}
          />
          <FormSelectRow
            label="Start Point"
            name="startPoint"
            value={formik.values.startPoint}
            onChange={e => formik.setFieldValue("startPoint", e.target.value)}
            options={pointOptions}
          />
          <FormSelectRow
            label="End Point"
            name="endPoint"
            value={formik.values.endPoint}
            onChange={e => formik.setFieldValue("endPoint", e.target.value)}
            options={pointOptions}
          />
          <CourierActions
            loading={loading}
            submitLabel="Add Round"
            onCancel={closeModal}
          />
        </Form>
      )}
    </Formik>
  </FormModalShell>
);

export default CreateRoundForm;
